import React from 'react';
import { motion } from 'framer-motion';
import { FaMapMarkerAlt, FaEnvelope, FaClock } from 'react-icons/fa';
import SectionHeading from '../ui/SectionHeading';

const TradingContactSection = () => {
  const contactInfo = [
    {
      icon: FaMapMarkerAlt,
      title: 'Head Office',
      details: ['Caishen Capital Ltd.', 'Govant Building, BP 1276, Port Vila', 'Efate, Vanuatu']
    },
    {
      icon: FaEnvelope,
      title: 'Trading Email',
      details: ['trading@caishen.capital']
    },
    {
      icon: FaClock,
      title: 'Trading Hours',
      details: ['Monday - Friday', '08:00 - 18:00 VUT (UTC+11)', 'Emergency trading support available 24/7']
    }
  ];

  return (
    <section id="contact" className="section-padding bg-black relative">
      {/* Background gradient */}
      <div className="absolute top-0 left-0 -translate-y-1/2 -translate-x-1/4 w-[800px] h-[800px] rounded-full bg-primary-500/10 blur-[100px] pointer-events-none"></div>
      
      <div className="container-custom relative z-10">
        <SectionHeading
          subtitle="Contact Us"
          title="Ready to Trade?"
          description="Get in touch with our trading team to discuss your hydrocarbon requirements and explore partnership opportunities."
        />
        
        <div className="mt-16">
          <div className="glass-card-strong p-8 md:p-10">
            <div className="grid md:grid-cols-3 gap-8">
              {contactInfo.map((item, index) => (
                <motion.div
                  key={item.title}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6, delay: index * 0.2 }}
                  viewport={{ once: true }}
                  className="text-center"
                >
                  <div className="mb-4">
                    <div className="w-12 h-12 rounded-full bg-white/10 flex items-center justify-center mx-auto">
                      <item.icon className="text-primary-400 w-5 h-5" />
                    </div>
                  </div>
                  <h4 className="text-xl font-bold mb-3">{item.title}</h4>
                  {item.details.map((detail) => (
                    <p key={detail} className="text-gray-300">{detail}</p>
                  ))}
                </motion.div>
              ))}
            </div>
            
            <div className="mt-12 pt-8 border-t border-gray-800 text-center">
              <h4 className="text-xl font-bold mb-4">Trading Specializations</h4>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-gray-300">
                <div>
                  <span className="text-accent-gold font-semibold">EN590</span>
                  <p className="text-sm">European Standard Diesel</p>
                </div>
                <div>
                  <span className="text-accent-gold font-semibold">Crude Oil</span>
                  <p className="text-sm">Brent & WTI Varieties</p>
                </div>
                <div>
                  <span className="text-accent-gold font-semibold">D6 Fuel</span>
                  <p className="text-sm">Marine & Industrial</p>
                </div>
                <div>
                  <span className="text-accent-gold font-semibold">Jet A1</span>
                  <p className="text-sm">Aviation Turbine Fuel</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TradingContactSection;